import React from 'react';
import '../Login/Modal.css';

const DeleteConfirmModal = ({ show, onClose, onConfirm, user }) => {
  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header" style={{ backgroundColor: 'var(--color-danger-light)' }}>
          <h3 style={{ color: 'var(--color-danger-dark)' }}>⚠️ 刪除用戶</h3>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          <div style={{ 
            backgroundColor: 'var(--color-danger-light)', 
            padding: 'var(--spacing-md)', 
            borderRadius: 'var(--border-radius-md)',
            marginBottom: 'var(--spacing-md)'
          }}>
            <p style={{ margin: 0, color: 'var(--color-danger-dark)', fontWeight: 500 }}>
              ⚠️ 此操作無法復原
            </p>
          </div>
          <p style={{ color: 'var(--color-text-secondary)' }}>
            確定要刪除用戶 <strong>{user?.name}</strong> ({user?.email}) 嗎？
          </p>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>取消</button>
          <button className="btn btn-danger" onClick={onConfirm}>確認刪除</button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
